/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { NodeType } from './nodeType'
import type { ScenarioNodeConfig } from './scenarioNodeConfig'
import type { ScenarioNodeSurveyId } from './scenarioNodeSurveyId'

export interface ScenarioNode {
  updatedAt: string
  createdAt: string
  /**
   * 追加設定。SURVEYノードは routing config { routingQuestionId?, routing?, defaultTargetNodeKey } を持つ（#263: defaultTargetNodeKey / #265: routingQuestionId+routing で回答分岐・ADR-0011）
   * @nullable
   */
  config: ScenarioNodeConfig
  title: string
  /**
   * 参照する Survey（アンケート集約）。SURVEYノードのみ設定・複数ノードで共有可（ADR-0011）
   * @nullable
   */
  surveyId: ScenarioNodeSurveyId
  videoId: Cuid
  /** ノード種別。SURVEY はノードベース型（POPUP/BOX/WIDE）の全画面ゲート（ADR-0011/0016） */
  type: NodeType
  nodeKey: string
  scenarioId: Cuid
  id: Cuid
}
